var portfolioPositionsPerformance = {
	caption: "Portfoliopositionen Performance",
	label: {
		name: "Name",
		isin: "ISIN",
		performance: "Perf.",
		performanceRelative: "Perf. %",
		performanceBar: "Perf. % von max"
	},
	noPositions: "Keine Ergebnisse gefunden."
};
var de = {
	portfolioPositionsPerformance: portfolioPositionsPerformance
};

export { de as default, portfolioPositionsPerformance };
